export default __webpack_public_path__ + "static/media/Shanna-Davies.faa359c4.jpg";